import { render, staticRenderFns } from "./operationRecordTask.vue?vue&type=template&id=2ce788d4&scoped=true"
import script from "./operationRecordTask.vue?vue&type=script&lang=js"
export * from "./operationRecordTask.vue?vue&type=script&lang=js"
import style0 from "./operationRecordTask.vue?vue&type=style&index=0&id=2ce788d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce788d4",
  null
  
)

export default component.exports